import PropTypes from "prop-types";
import React, {Component} from "react";
import {CategoryCard} from "./CategoryCard";
import {Container, ScrollableContainer} from "../../../../../../components";
import styles from "./styles";


// class definition
export class CategoryList extends Component {

    static propTypes = {
        categories: PropTypes.array.isRequired,
        onCategorySelected: PropTypes.func
    };

    static defaultProps = {
        onCategorySelected: () => undefined
    };

    render() {

        // resolve input
        const {categories, onCategorySelected} = this.props;

        // create cards
        const cards = categories.map(c => (
            <CategoryCard
                key={c.id}
                category={c}
                onPress={() => onCategorySelected(c)}/>
        ));

        // render view
        return (
            <ScrollableContainer style={styles.container}>
                <Container flex direction="row">
                    {cards}
                </Container>
            </ScrollableContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/CategoryList.js